import { render, staticRenderFns } from "./RekognitionForm.vue?vue&type=template&id=5e7f4dee&scoped=true&"
import script from "./RekognitionForm.vue?vue&type=script&lang=js&"
export * from "./RekognitionForm.vue?vue&type=script&lang=js&"
import style0 from "./RekognitionForm.vue?vue&type=style&index=0&id=5e7f4dee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7f4dee",
  null
  
)

export default component.exports